import localforage from 'localforage';

// Configure a store specifically for logs
// pgw 17-oct-2025 Change from ChoirPlayer to ChoirPlayerLogsApp to avoid version coupling
const logStore = localforage.createInstance({
  name: 'ChoirPlayerLogsApp',
  storeName: 'debugLogsApp',
  description: 'App debug logs stored in IndexedDB',
});

/**
 * Save a log message with a timestamp.
 */
export async function logToIndexedDB3(message) {
  const timestamp = new Date().toISOString();
  const entry = { timestamp, message };

  try {
    const existing = (await logStore.getItem('logs')) || [];
    existing.push(entry);
    await logStore.setItem('logs', existing);
  } catch (err) {
    console.error('Failed to write log to IndexedDB:', err);
  }
}

let logWriting = Promise.resolve();

export function logToIndexedDB(...args) {

  const timestamp = new Date().toISOString();
  const message = args.map(a => 
    typeof a === 'object' ? JSON.stringify(a) : String(a)
  ).join(' ');

  const entry = { timestamp, message };

  // pgw 30-sep-2025 - remove for release (maybe put back with runtime flag later...)
/*
  if (false) {
	  logWriting = logWriting.then(async () => {
		try {
		  const existing = (await logStore.getItem('logs')) || [];
		  existing.push(entry);
		  await logStore.setItem('logs', existing);
		} catch (err) {
		  console.error('Failed to write log to IndexedDB:', err);
		}
	  });
  }
*/
  try {

	// pgw 01-oct-2025 - temp testing
	// let flag = '1'

	// pgw 17-oct-2025
	let flag = '0'
    // const flag = window.localStorage.getItem('__debug_logs_enabled');

//     console.log('logToIndexedDB flag = ', flag);
    if (flag === '1') {
	  logWriting = logWriting.then(async () => {
		try {
		  const existing = (await logStore.getItem('logs')) || [];
		  existing.push(entry);
		  await logStore.setItem('logs', existing);
		} catch (err) {
		  console.error('web Failed to write log to IndexedDB:', err);
		}
	  });
    }
  } catch (e) {
    // fallback: just ignore
	console.log('logToIndexedDB e = ', e);
  }

  return logWriting;
}


/**
 * Get all logs
 */
export async function getLogsFromIndexedDB() {
  return await logStore.getItem('logs');
}

/**
 * Clear all logs
 */
export async function clearLogsFromIndexedDB() {
  return await logStore.removeItem('logs');
}